window.addToast = function(type, text) {
	let toasts = document.getElementById('toasts');
	let div = document.createElement('div');
	div.classList.add('toast', 'align-items-center', 'text-white', 'bg-' + type, 'border-0');
	div.innerHTML = '<div class="d-flex"><div class="toast-body">' + text + '</div><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div>';
	toasts.appendChild(div);
	let toast = new bootstrap.Toast(div, { delay: 3000 });
	toast.show();
	div.addEventListener('hidden.bs.toast', function() {
		this.remove();
	});
}
